export default "__VITE_ASSET__LRvit94B__"